// src/components/explorers/wildfireExplorer/wildfireServiceAdapter.ts
// Service adapter — calls the frontend wildfireService (no direct UDL).

import { EntityServiceAdapter, QueryParams, QueryResult } from '../../../types/baseExplorerConfig';
import { WildfireEntity } from '../../../types/wildfire';
import { wildfireService } from '../../../services/wildfireService';
import { objectToSearchParams } from '../baseExplorer/objectToSearchParams';
import { backendPage, pageHasMore } from '../../../utils/pagination';
import { translateWildfireParams } from './wildfireParams';

export const wildfireServiceAdapter: EntityServiceAdapter<WildfireEntity> = {

  async fetchData(params: QueryParams): Promise<QueryResult<WildfireEntity>> {
    try {
      const wildfireParams: any = {
        ...backendPage(params),
        ...translateWildfireParams(params),
      };

      const response = await wildfireService.fetchData(wildfireParams);

      return {
        data: response.data.map((wildfire: any) => ({
          ...wildfire,
          _id: wildfire._id || wildfire.fire_id,
        })),
        total: response.total,
        page: response.page,
        limit: response.limit,
        hasMore: pageHasMore(response.page, response.limit, response.total),
      };
    } catch (error) {
      console.error('WFE ServiceAdapter Error:', error);
      throw error;
    }
  },

  buildExportParams: (params: QueryParams) => objectToSearchParams(translateWildfireParams(params)),

  async createEntity(data: Omit<WildfireEntity, 'fire_id' | 'created_at' | 'updated_at'>): Promise<WildfireEntity> {
    try {
      return await wildfireService.create(data as any);
    } catch (error) {
      console.error('WFE ServiceAdapter Create Error:', error);
      throw error;
    }
  },

  async updateEntity(id: string, updates: Partial<WildfireEntity>): Promise<WildfireEntity> {
    try {
      return await wildfireService.update(id, updates as any);
    } catch (error) {
      console.error('WFE ServiceAdapter Update Error:', error);
      throw error;
    }
  },

  async deleteEntity(id: string): Promise<boolean> {
    try {
      return await wildfireService.delete(id);
    } catch (error) {
      console.error('WFE ServiceAdapter Delete Error:', error);
      throw error;
    }
  },
};
